import { render, staticRenderFns } from "./CutOffDateTypeSelect.vue?vue&type=template&id=1b87de95&scoped=true&lang=pug"
import script from "./CutOffDateTypeSelect.vue?vue&type=script&lang=js"
export * from "./CutOffDateTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b87de95",
  null
  
)

export default component.exports